import React from "react";

const Impact = ({ data }) => {
  const { office, constituency } = data || {};

  if (!office || !constituency) {
    return null;
  }

  const impactItems = [
    [
      office.institution_value || "—",
      "Assembly",
    ],

    [
      office.start_year || "—",
      "Current Tenure",
    ],

    [
      office.constituency_label || "—",
      "Constituency",
    ],

    [
      constituency.ward?.split(/\s+/)[0] || "—",
      "Ward",
    ],
  ];

  return (
    <section
      className="impact-section section-padding"
      aria-labelledby="impact-title"
    >
      <div className="container">

        <div className="impact-heading">

          <div>
            <p className="section-label light">
              <span />
              PUBLIC SERVICE
            </p>

            <h2 id="impact-title">
              Measuring impact through{" "}
              <em>meaningful service.</em>
            </h2>
          </div>

          <p>
            Verified legislative and constituency
            information will be presented here as
            the office's public record develops.
          </p>

        </div>

        <div className="impact-grid">

          {impactItems.map(([value, label]) => (
            <div
              className="impact-item"
              key={label}
            >
              <strong>{value}</strong>
              <span>{label}</span>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default Impact;